"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarComboBoxFilter = /** @class */ (function (_super) {
    __extends(ToolBarComboBoxFilter, _super);
    function ToolBarComboBoxFilter(props) {
        return _super.call(this, props) || this;
    }
    ToolBarComboBoxFilter.prototype.onSelectValue = function (value, option) {
        //console.log(`Selected -> ${JSON.stringify(value)}`);
        if (this.props.onFilterChanged) {
            this.props.onFilterChanged(this.props.allItems, parseInt(value.key));
        }
    };
    ToolBarComboBoxFilter.prototype.onDeSelectValue = function (value, option) {
        //console.log(`DeSelected -> ${JSON.stringify(value)}`);
        if (this.props.onFilterChanged) {
            this.props.onFilterChanged(this.props.allItems, parseInt(value.key));
        }
    };
    ToolBarComboBoxFilter.prototype.onCheckBoxChecked = function (checked) {
        if (this.props.onFilterChanged) {
            this.props.onFilterChanged(checked, 0);
        }
    };
    ToolBarComboBoxFilter.prototype.getSelectItems = function () {
        var _ret = [];
        //console.log(`total brands -> ${this.props.avail_brands.length}`);
        for (var i = 0; i < this.props.availItems.length; i++) {
            //console.log(`key  -> ${this.props.avail_brands[i].key} val -> ${this.props.avail_brands[i].value}`);
            _ret.push(React.createElement(antd_1.Select.Option, { key: "" + i, value: "" + this.props.availItems[i].key }, this.props.availItems[i].value));
        }
        return _ret;
    };
    ToolBarComboBoxFilter.prototype.getSelectedValues = function () {
        var _ret = [];
        // for (let j = 0; j < this.props.selectedBrands.length; j++) {
        for (var i = 0; i < this.props.availItems.length; i++) {
            if (this.props.availItems[i].key === this.props.selectedItem) {
                _ret.push({
                    key: this.props.availItems[i].key.toString(),
                    label: this.props.availItems[i].value
                });
                break;
            }
        }
        //}
        return _ret;
    };
    ToolBarComboBoxFilter.prototype.getCheckBoxTitle = function () {
        if (this.props.isHideAllItemsCheckBox) {
            return null;
        }
        else {
            return (React.createElement("div", { style: { marginLeft: "5px", marginRight: "5px", whiteSpace: "nowrap" } }, this.props.captions.checkbox));
        }
    };
    ToolBarComboBoxFilter.prototype.getCheckBoxItem = function () {
        if (this.props.isHideAllItemsCheckBox) {
            return null;
        }
        else {
            return (React.createElement(antd_1.Switch, { checked: this.props.allItems, onChange: this.onCheckBoxChecked.bind(this) }));
        }
    };
    ToolBarComboBoxFilter.prototype.render = function () {
        return (React.createElement("div", { style: { display: "flex", width: this.props.width, flexWrap: "nowrap", justifyContent: "flex-start", alignItems: "center" } },
            this.getCheckBoxTitle(),
            this.getCheckBoxItem(),
            React.createElement(antd_1.Select, { style: { width: '100%', marginLeft: "5px" }, placeholder: this.props.captions.placeholder, value: this.getSelectedValues(), labelInValue: true, onDeselect: this.onDeSelectValue.bind(this), onSelect: this.onSelectValue.bind(this), disabled: this.props.allItems }, this.getSelectItems())));
    };
    return ToolBarComboBoxFilter;
}(React.Component));
exports.default = ToolBarComboBoxFilter;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/toolbars/ToolBarComboBoxFilter.tsx
// module id = 197
// module chunks = 0